import { useTranslation } from '@rhino-project/core/i18n';
import {
  Tabs,
  TabListContainer,
  TabList,
  Tab,
  TabIndicator
} from '@heroui/react';
import { type AppMode } from '../../contexts/ModeContext';
import { useMode } from '../../hooks/useMode';
import { useNavigate } from '@tanstack/react-router';
import { useBaseOwnerId } from '@rhino-project/core/hooks';
import { useActiveSeasons } from '../../hooks/ots';

export function ModeSwitcher() {
  const { t } = useTranslation();

  const { mode, setMode } = useMode();
  const navigate = useNavigate();
  const owner = String(useBaseOwnerId());
  const { resources: active_seasons } = useActiveSeasons();
  const activeSeasonName = (
    active_seasons?.results?.[0] as { season?: { name?: string } } | undefined
  )?.season?.name;

  const modes: { id: AppMode; label: string }[] = [
    { id: 'plan', label: t('frontend.messages.plan') },
    { id: 'season', label: activeSeasonName ?? t('frontend.messages.season') }
  ];

  const handleModeChange = (key: AppMode) => {
    setMode(key);

    switch (key) {
      case 'plan':
        navigate({
          to: '/$owner/plan',
          params: { owner },
          replace: true
        });
        break;
      case 'season':
        navigate({
          to: '/$owner',
          params: { owner },
          replace: true
        });
        break;
    }
  };

  return (
    <Tabs
      selectedKey={mode}
      onSelectionChange={(key) => handleModeChange(key as AppMode)}
      aria-label={t('frontend.messages.app_mode')}
    >
      <TabListContainer>
        <TabList className="gap-0">
          {modes.map((m) => (
            <Tab key={m.id} id={m.id} className="flex-1 justify-center">
              {m.label}
              <TabIndicator />
            </Tab>
          ))}
        </TabList>
      </TabListContainer>
    </Tabs>
  );
}
